<template>
  <modal
    :show.sync="isActiveViewtest"
    size="lg"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
    @close="closeModal"
  >
    <div class="flex justify-end">
      <img
        src="@/assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveViewtest = false"
      />
    </div>
    <h2 class="fsize25 sm-fsize18 text-center">Show us your love</h2>
    <p class="fsize20 sm-fsize16 text-center">
      Your Testimonial is like a virtual hug for us that will energize us
    </p>

    <div class="mt-4">
      <!-- <FileUploader
        v-show="!image"
        :image="image"
        :onSuccess="handleSuccess"
        class="rounded-full widtht20percent m-auto display-none custmodal"
      /> -->
      <img
        v-if="image"
        :src="`${$imageURL}/${image}`"
        ref="cover"
        class="rounded-full widtht20percent m-auto display-none custmodal"
      />
      <!-- <p class="text-center">Upload your picture (optional)</p> -->
    </div>
    <div class="py-4 customboxed">
      <p class="mb-1">We would love to know who are you</p>
      <base-input class="" disabled name="Link" v-model="name"> </base-input>
    </div>
    <div class="customboxed">
      <p class="mb-1">What do you do</p>
      <base-input disabled class="mb-3" name="Link" v-model="profession">
      </base-input>
    </div>
    <div class="mb-4">
      <p class="mb-1">How do you relate with Caregiver Saathi</p>
      <base-input
        disabled
        class="mb-3"
        name="Link"
        v-model="relate"
      ></base-input>
      <!-- <b-form-select
        class="w-full custinputborder py-2"
        disabled
        v-model="this.relate"
      > -->
      <!-- <option selected>{{ this.relate }}</option> -->
      <!-- <option value="1">One</option>
        <option value="2">Two</option>
        <option value="3">Three</option> -->
      <!-- </b-form-select> -->
    </div>
    <div class="customboxed">
      <p class="mb-1">
        Tell us what else we could do, that will be meaningful for caregivers
      </p>
      <base-input disabled class="mb-3" name="Link" v-model="suggestion">
      </base-input>
    </div>
    <div class="customboxed">
      <p class="mb-1">Description</p>
      <b-form-textarea
        disabled
        class="mb-3 w-full py-2"
        name="Link"
        v-model="description"
      >
      </b-form-textarea>
    </div>
    <div class="flex">
      <b-checkbox v-model="isHidden" disabled />
      <p>Do you want to keep your name hidden</p>
    </div>
    <base-button
      type="primary"
      class="w-full my-2 fsize18"
      @click="isActiveViewtest = false"
      >Close</base-button
    >
    <!-- <div v-html="selectedTesimonial.html"></div> -->
    <template slot="footer"> <div></div> </template>
  </modal>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import { mapState } from "vuex";
export default {
  data() {
    return {
      name: "",
      description: "",
      isHidden: false,
      profession: "",
      relate: "",
      suggestion: "",
      image: null,
    };
  },
  components: {
    FileUploader,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectviewTesimonial: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    selectviewTesimonial(val) {
      if (val && this.isActiveViewtest) {
        this.getTestimonial();
      }
    },
  },

  computed: {
    isActiveViewtest: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
    ...mapState("testimonial", {
      singleTestimonial: "singleTestimonial",
    }),
  },

  methods: {
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async getTestimonial() {
      let loader;
      try {
        let payload = {
          testimonialId: this.selectviewTesimonial._id,
        };
        loader = this.$loading();
        const allTestimonial = await this.$store.dispatch(
          "testimonial/getTestimonial",
          payload
        );

        if (allTestimonial.code === 200) {
          this.name = this.singleTestimonial.name;
          this.description = this.singleTestimonial.description;
          this.isHidden = this.singleTestimonial.isHidden;
          this.profession = this.singleTestimonial.profession;
          this.relate = this.singleTestimonial.relate;
          this.suggestion = this.singleTestimonial.suggestion;
          this.image = this.singleTestimonial.image;
        }

        loader.close();
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style>
.custinputborder {
  border: 1px solid #808080;
  border-radius: 4px;
}
.widtht20percent {
  width: 24%;
  height: 140px !important;
}
.modal-lg {
  width: 650px;
}
@media (max-width: 640px) {
  .modal-lg {
    width: 330px;
  }
  .widtht20percent {
    width: 50%;
    height: 140px !important;
  }
}
</style>
